import React from 'react';
import { Modal, Image, Button } from 'react-bootstrap';
import SalirIcon from '../../../../Images/salir.svg';
import { Bounce } from 'react-activity';
import './modalBlock.css'

export const ModalBlock = (props) => {
  return(
    <Modal
      id="block_card"
      className="modal_settings"
      size="sm"
      show={props.show}
      aria-labelledby="example-modal-sizes-title-sm"
    >
      <Modal.Header style={{display: 'flex', flexDirection: 'column'}} className='custom-header-settings'>
        <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
          <Image src={SalirIcon} onClick={props.closeModal} alt="X" style={{cursor: 'pointer'}}/>
        </div>
        <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          {props.unblocked ?
          <Modal.Title className="title-settings">{props.traductions.Card.enabled.modalBlockPhysical.title}</Modal.Title> 
          : <Modal.Title className="title-settings">{props.traductions.Card.enabled.modalBlockPhysical.titleUnblock}</Modal.Title> 
          }
        </div>
      </Modal.Header>
      <Modal.Body style={{padding: '10px 53px 53px'}}>
      {/* ¿Estás seguro de que quieres bloquear tu tarjeta? No podrás usarla hasta que la desbloquees de nuevo */}
      <p className='text-block'>
        {props.unblocked ?<>
          {props.traductions.Card.enabled.modalBlockPhysical.body}        
        </> :
        <>
        {props.traductions.Card.enabled.modalBlockPhysical.bodyUnblock}        
        </>}
      </p>
      <div style={{textAlign: 'center'}}>
        <Button className='btn-block-card' onClick={props.block} disabled={props.spinner}>
          {
            props.spinner ? 
            <Bounce size={20} color={"#FFFFFF"} animating={props.spinner} />
            :
            <p style={{margin: 0}}>{props.unblocked ? props.traductions.Card.enabled.modalBlockPhysical.title : props.traductions.Card.enabled.modalBlockPhysical.titleUnblock}</p>
          }
        </Button>
      </div>
      </Modal.Body>
  </Modal>
  )
}

